import { Message } from '@wix/chat-sdk';
import wix from '../services/wix';
import { ViewerOnMessageSentEvent } from '../constants/viewer-event-types';
import { lazyLoaders } from '../services/loading-scheduler';

export const sendMessage = ({
  message,
  chatroom,
  requestId,
}: {
  message: string;
  chatroom?: string;
  requestId: string;
}) => {
  return async function (dispatch, getState) {
    const responseEventName = `ChatWidget.sendMessageResponse.${requestId}`;
    if (!message) {
      console.error('`message` must be populated when sending message');
      return wix.publishToPubSub(responseEventName, { success: false });
    }

    try {
      const defaultChatroomId = getState().businessChatRoomId;
      const userId = getState().chatInitResult.visitorId;
      const createdAt = new Date().getDate();
      const messageParam = {
        createdAt,
        summary: message,
        chatroomId: chatroom ? chatroom : defaultChatroomId,
        sender: {
          type: 'Visitor',
          userId,
        },
        text: message,
        data: [{ data: { text: message } }],
      };

      const messageObj: Message = Message.fromText(messageParam);
      const lazySdk = await lazyLoaders.interactivity.chatSdk();
      lazySdk.chatSdk.sendMessage(messageObj);
      wix.publishToPubSub(ViewerOnMessageSentEvent, messageParam);

      wix.publishToPubSub(responseEventName, { success: true });
    } catch (e) {
      console.error('Catch an error in sendMessage Action,', e);
      wix.publishToPubSub(responseEventName, { success: false });
    }
  };
};
